<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <!-- <el-col :span="24">
          <el-form-item label="选择场所类型" prop="type">
            <el-select v-model="form_data.type" placeholder="全部" clearable>
              <el-option v-for="(item, index) in PLACE_STATE" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="状态" prop="is_active">
            <el-switch v-model="form_data.is_active" :active-value="1" :inactive-value="0"  active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item label="添加等级" prop="type_level">
            <el-radio-group v-model="form_data.type_level">
              <el-radio :label="parseInt(index)" v-for="(item,index) in MATERIAL_LEVEL" :key="index" @change="changes">{{item}} </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="上级" prop="pid">
            <el-cascader v-model="form_data.pid" :options="tree_node" :props="{ checkStrictly: true }" clearable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="编码(纯数字)" prop="id">
            <el-input v-model="form_data.id" autocomplete="off" placeholder="请输入数字编码"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="代码(国标)" prop="type_code">
            <el-input v-model="form_data.type_code" autocomplete="off" placeholder="请输入国标代码"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="分类名" prop="name">
            <el-input v-model="form_data.name" autocomplete="off" maxlength="250" placeholder="请输入分类名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="缩写" prop="abbreviation">
            <el-input v-model="form_data.abbreviation" autocomplete="off" placeholder="请输入缩写"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item label="中类" prop="name" v-if="form_data.type_level == 2">
            <el-input type="textarea" v-model="form_data.name" autocomplete="off" :rows="6" maxlength="250" placeholder="请输入中类"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="小类" prop="name" v-if="form_data.type_level == 3">
            <el-input type="textarea" v-model="form_data.name" autocomplete="off" :rows="6" maxlength="250" placeholder="请输入小类"></el-input>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="24">
          <el-form-item label="标准检查等级" prop="danger_lavel" v-if="form_data.grade == 3">
            <el-radio-group v-model="form_data.danger_lavel">
              <el-radio :label="parseInt(index)" v-for="(item,index) in LEVEL" :key="index">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
      </el-row>

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
import { MATERIAL_LEVEL, PLACE_STATE, STATE_NAMES, LEVEL } from '../public/basis.js';
export default {
  name: 'l-material-type-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    }
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中

      //资源类型
      MATERIAL_LEVEL: MATERIAL_LEVEL,
      PLACE_STATE: PLACE_STATE,
      STATE_NAMES: STATE_NAMES,
      LEVEL: LEVEL,
      //是否显示
      tree_node: [

      ],
      //表单数据
      form_data: {
        //场所类型 公共场所 
        // place_type: 4,
        name: '',
        is_active: 1,
        id:'',
        pid: [],
        // fraction: 0,
        // inspection_method: '',
        // danger_lavel: ''
      },
      //表单验证规则
      rules: {
        id: [
          {type: 'number', required: true, message: '编码不能为空', trigger: 'change', transform: (value) => Number(value)}
        ],
        name: [
          { required: true, message: '名称不能为空', trigger: 'change' }
        ],
        pid: [
          { required: true, message: '分类上级不能为空', trigger: 'change' }
        ],
        is_active: [
          { required: true, message: '状态不能为空', trigger: 'change' }
        ],

      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    changes() {
      this.$_invoke("materialType_getSuperior", {
        type_level: this.form_data.type_level,
        place_type: this.form_data.place_type
        // pid_ids: this.form_data.street_ids
      }).then((ret) => {
        // console.log(ret)
        this.tree_node = ret
      })
        .finally(() => {
          this.loading = false;
        });
    },
    //获取数据
    getData() {
      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`materialType_getEditData`, { id: this.$props.id }).then((ret) => {
          this.form_data = ret.data;
          this.tree_node = ret.tree_node_material_type;
        }).finally(() => {
          this.loading = false;
        });

      } else {
        this.loading = true;
        this.$_invoke(`materialType_getMaterialTypeTreeNodes`).then((ret) => {
          this.tree_node = ret.tree_node_material_type;
        }).finally(() => {
          this.loading = false;
        });  
          
        // this.form_data.use_type = this.$props.useType
      }
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (typeof this.form_data.pid != "number" && this.form_data.pid.length != 0) {
            const pid_len = this.form_data.pid.length;
            this.form_data.pid = this.form_data.pid[pid_len - 1];
          } else {
              this.form_data.pid = 0;
          }
          this.submitting = true;
          if (!this.hasId) {//添加是·
            this.$_invoke('materialType_save',
              this.form_data).then(() => {
                this.$_msg.success('添加成功');
                this.$emit('on-success');
              }).finally(() => {
                this.submitting = false;
              })
          } else {//修改
            this.$_invoke(`materialType_update`, {
              id: this.$props.id,
              ...this.form_data
            }).then(() => {
              this.$_msg.success('修改成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          }
        }
      })

    },
  },
}
</script>